import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  LedgerTotal as LedgerTotalComponent,
  LedgerTotalProps,
} from "../../components/LedgerTotal/LedgerTotal";
import { getLedgerHead as getLedgerHeadAction } from "../../actions";
import { StoreState } from "../../reducers";
import { getLedgerHead, getRewardRequestStatus } from "../../reducers/methods";
import { customerAuthenticationOccurred } from "../../utils/customer";

interface LedgerTotalContainerProps extends LedgerTotalProps {
  getLedgerHeadAction: typeof getLedgerHeadAction;
  ledgerHead: ReturnType<typeof getLedgerHead>;
  requestStatus: ReturnType<typeof getRewardRequestStatus>;
  currency?: string;
}

class LedgerTotal extends React.Component<LedgerTotalContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (
      isCustomerAuthenticated &&
      this.props.requestStatus.getLedger !== "REQUESTING"
    ) {
      this.props.getLedgerHeadAction({
        currency: this.props.currency || "USD",
      });
    }
  }

  componentDidUpdate(prevProps: LedgerTotalContainerProps) {
    if (customerAuthenticationOccurred(prevProps.data, this.props.data)) {
      this.props.getLedgerHeadAction({
        currency: this.props.currency || "USD",
      });
    }
  }

  render() {
    return <LedgerTotalComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  ledgerHead: getLedgerHead(state),
  requestStatus: getRewardRequestStatus(state),
});

export default connect(mapStateToProp, {
  getLedgerHeadAction,
})(LedgerTotal);
